import {
	Component,
	OnInit,
	QueryList,
	TemplateRef,
	ViewChildren,
} from '@angular/core';

@Component({
	selector: 'app-week',
	templateUrl: './week.component.html',
	styleUrls: ['./week.component.scss'],
})
export class WeekComponent {
	// bread crumb items
	breadCrumbItems!: Array<{}>;
	loadingExcel: boolean = false;
	submitted = false;
}
